import { render, staticRenderFns } from "./ProgramVideo.vue?vue&type=template&id=d9c30ab2&"
import script from "./ProgramVideo.vue?vue&type=script&lang=js&"
export * from "./ProgramVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports